module.exports = __webpack_public_path__ + "img/p7.67e8c3f0.png";